import { Card } from "antd";
import {
  PhoneOutlined,
  ClockCircleOutlined,
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import { EmailIcon } from "../../assets/CustomIcon";

import Header from "../../components/common/Layouts/Header";
import Footer from "../../components/common/Layouts/Footer";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import "../../assets/styles/components_styles/supportModule.css";

const SOCIAL_LINKS = [
  { icon: <FacebookOutlined />, href: "https://www.facebook.com", label: "Facebook" },
  { icon: <InstagramOutlined />, href: "https://www.instagram.com", label: "Instagram" },
  { icon: <LinkedinOutlined />, href: "https://www.linkedin.com", label: "LinkedIn" },
  { icon: <YoutubeOutlined />, href: "https://www.youtube.com", label: "YouTube" },
];

export default function HelpPage() {
  return (
    <>
      <HelmetWrapper
        title="Help - Pingvite"
        description="Reach out to Pingvite for support, partnership, and event related enquiries."
        keywords="Pingvite react out to us, event enquiry, support, social links"
      />
      {/* HEADER */}
      <Header isHome={false} />

      {/* CONTENT */}
      <main className="supportModulePageRoot">
        <section className="supportModuleSection">
          <div className="container">
            <div className="supportModuleContent">
              <div className="supportModuleWrap">
                <h1 className="supportModuleTitle">Help</h1>
                <span className="supportModuleTitleUnderline" />

                <Card className="supportModuleCard" bordered={false}>
                  <div className="supportModuleGrid">
                    <div className="supportModuleCol">
                      <p className="supportModuleMeta">
                        <PhoneOutlined />
                        <a href="tel:9007222405">9007222405</a>
                      </p>
                      <p className="supportModuleMeta">
                        <EmailIcon />
                        <a href="mailto:info@pingvite.com">info@pingvite.com</a>
                      </p>
                      <p className="supportModuleMeta">
                        <ClockCircleOutlined />
                        08:00 AM to 08:00 PM
                      </p>
                    </div>

                    <div className="supportModuleCol">
                      <h3 className="supportModuleHeading">Socials</h3>
                      <p className="supportModuleText">
                        Follow us for exciting updates and offers!
                      </p>
                      <div className="supportModuleSocials">
                        {SOCIAL_LINKS.map((item) => (
                          <a
                            key={item.label}
                            href={item.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={item.label}
                            className="supportModuleSocialLink"
                          >
                            {item.icon}
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <Footer />
    </>
  );
}